import translate from '@translate';
import React, { FC, ReactNode } from 'react';
import TableSimple from 'src/components/TableSimple';
import Typography from 'src/components/Typography';
import { sizes } from 'src/themes/default';
import { TransportLinkedOrderType } from 'src/types/transport';
import { TableColumnType, TableRowType } from 'src/types/table';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

export interface LinkedOrdersTablePropsType {
    orders?: TransportLinkedOrderType[] | null;
}

const linkedOrdersColumns: TableColumnType[] = [
    { key: 'ID', label: 'id' },
    { key: 'ESHOP_ORDER_ID', label: 'eshopOrderId' },
    { key: 'ROLE', label: 'role', customRender: true },
];

const roleLabel = (role: string | undefined): string => {
    if (role === 'system') {
        return translate('transportDetail.linkedOrders.roleSystem');
    }
    if (role === 'manual') {
        return translate('transportDetail.linkedOrders.roleManual');
    }
    return role ?? '';
};

const LinkedOrdersTable: FC<LinkedOrdersTablePropsType> = (props) => {
    const rows =
        props.orders?.map((order) => ({
            ...order,
            ROLE: roleLabel(order.ROLE),
        })) ?? [];

    if (!rows.length) {
        return null;
    }

    return (
        <div data-testid="transport-linked-orders">
            <Typography variant="h3" gutterBottom sx={{ marginTop: sizes.blocks_top_MG }}>
                {translate('transportDetail.linkedOrders.title')}
            </Typography>
            <TableSimple
                rowIdKey="ID"
                rows={rows}
                columsLabelPrefix="transportDetail.linkedOrders"
                allColumns={linkedOrdersColumns}
                initSort={{ column: 'ID', direction: 'ASC' }}
                customRender={(column: TableColumnType, row: TableRowType): ReactNode =>
                    column.key === 'ROLE' ? row.ROLE : row[column.key]
                }
                rowActions={[
                    {
                        icon: <ShoppingCartIcon />,
                        label: translate('transportDetail.linkedOrders.orderDetail'),
                        getLink: (row) => `/orders/${row.ID}/`,
                    },
                ]}
                heightVariant="top-tab"
            />
        </div>
    );
};

export default LinkedOrdersTable;
